import { BuyGuideVendorBuyOpportunityDetails } from '../../../components/BuyGuide';

export function BuyGuideBuyOpportunityDetails() {
  return <BuyGuideVendorBuyOpportunityDetails />;
}
